import React, { useContext } from "react";
import { BookContext } from "../../context/books";
import Guia from '../GuiaList/Guia';
import Loading from "../Loader/Loader";
import "./GuiaList.css";


const BookList = () => {
    const {guias, loading, resultTitle } = useContext(BookContext);

    if(loading) return <Loading />;

    return (
        <section className='guialist'>
            <div className="container">
                <h2 className="result">{resultTitle}</h2>
            </div>
            <div className="guialist-content grid">
                {guias.slice(0, 98).map((item, index) => {
                    return (
                        <Guia key = {index} {... item} />
                    )
                })}
            </div>
        </section>
    )
}

export default BookList;